import { render, staticRenderFns } from "./WikiList.vue?vue&type=template&id=2de98e85&"
import script from "./WikiList.vue?vue&type=script&lang=ts&"
export * from "./WikiList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports